export function renderRich(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**") ? (
      <strong key={i} className="font-semibold text-[#12233F]">
        {p.slice(2, -2)}
      </strong>
    ) : (
      p
    )
  );
}
